var chunkToChildrenMap = {
	"4242": [
		5244,
		1365,
		6161,
		701,
		4886
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));